// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var Container = /** @class */ (function () {
    function Container(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(Container.prototype, "webview", {
        /**
         * ctr_webview 参数
         */
        get: function () {
            var ctr_webview = this.adapter.getStore().ctr_webview;
            return ctr_webview;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "orientation", {
        /**
         * ctr_orientation 参数
         */
        get: function () {
            var ctr_orientation = this.adapter.getStore().ctr_orientation;
            if (typeof ctr_orientation === "string" &&
                ["landscape", "portrait", "auto"].includes(ctr_orientation) === false) {
                return undefined;
            }
            return ctr_orientation;
        },
        enumerable: false,
        configurable: true
    });
    return Container;
}());
export { Container };
